import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconClappingProps } from './IconClapping.types'
import * as Styled from './styles/IconClapping.style'

import { nonThemeableRules } from '../../ruleSet'

const IconClapping: FC<IconClappingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconClappingProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconClappingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m10.059 10.82-1.16-.957c-.438-.355-1.06-.328-1.383.067l-.04.047c-.32.398-.226 1.007.208 1.367l1.191.98m3.835 3.156-3.835-3.152c-.438-.36-1.059-.332-1.375.063l-.04.046c-.32.395-.23 1.012.208 1.368l1.582 1.308'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='m11.492 16.96-2.25-1.847a.966.966 0 0 0-1.36.125l-.034.047c-.325.39-.235 1.012.203 1.367l2.215 1.817s3.57 3.023 5.656 3.07c1.512.035 2.465-.473 3.305-1.5.441-.539 1.59-1.637.918-4.125-1.211-4.5-1.696-6.539-1.696-6.539s-1.3-.04-1.347 1.508c-.024.875.449 2.363 0 2.527-.239.086-.684-.031-1.946-.91-.406-.281-3.875-3.176-3.875-3.176-.433-.36-1.054-.332-1.383.067l-.035.043c-.324.398-.238 1.015.203 1.375l3.852 3.164m-6.613 1.632-2.278-1.25c-.492-.273-.691-.863-.441-1.312l.031-.05v-.009c.266-.46.836-.683 1.297-.418l1.387.723-2.375-1.234c-.492-.274-.692-.864-.442-1.313l.032-.05c.25-.446.902-.594 1.394-.32'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M7.652 11.309 4.527 9.625c-.492-.273-.691-.863-.441-1.313l.031-.05c.25-.45.86-.586 1.352-.309l3.203 1.77-1.899-1.036c-.5-.273-.691-.867-.441-1.312l.027-.05c.25-.45.86-.59 1.352-.313 0 0 3.926 2.242 4.375 2.449 1.394.64 1.855.676 2.074.555.418-.243-.312-1.625-.441-2.493C13.5 6 14.78 5.805 14.78 5.805s1.41 2.812 2.328 4.933M8.469 4.906V2.777m3.019 3.141 1.602-1.602m-2.953.801L11.46 1.84'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconClapping
